import { createSelector } from 'reselect'

export const getServiceTypesLoading = createSelector(
  state => Boolean(state && state.ads && state.ads.serviceTypes && state.ads.serviceTypes.isLoading),
  isLoading => isLoading
)
